import actions from "./actions";

const initState = {
    bundleCreateState: false,
    bundleReadState: false,
    bundleUpdateState: false,
    bundleArchiveState: false,
    bundleDeleteState: false,
    bundleReadItemPriceState: false,
    bundleReadItemsPriceState: false,

    bundleCreateResult: {},
    bundleUpdateResult: {},
    bundleArchiveResult: {},

    bundle: {},
    itemWithPrice: {}, // used with bundleReadItemPriceState
    bundleWithPrice: {}, // used with bundleReadItemsPriceState
    isSelling: null,
    isBuying: null,
    total: 0,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.BUNDLE_CREATE_REQUEST:
            return {
                ...state,
                bundleCreateState: 'request',
            };
        case actions.BUNDLE_CREATE_SUCCESS:
            return {
                ...state,
                bundleCreateState: 'success',
                bundleCreateResult: action.bundle,
            };
        case actions.BUNDLE_READ_REQUEST:
            return {
                ...state,
                bundleReadState: 'request',
            };
        case actions.BUNDLE_READ_SUCCESS:
            return {
                ...state,
                bundleReadState: 'success',
                bundle: action.bundle,
                isSelling: action.bundle.is_selling,
                isBuying: action.bundle.is_buying,
            };
        case actions.BUNDLE_UPDATE_REQUEST:
            return {
                ...state,
                bundleUpdateState: 'request',
            };
        case actions.BUNDLE_UPDATE_SUCCESS:
            return {
                ...state,
                bundleUpdateState: 'success',
                bundleUpdateResult: action.bundle,
            };
        case actions.BUNDLE_ARCHIVE_REQUEST:
            return {
                ...state,
                bundleArchiveState: 'request',
            };
        case actions.BUNDLE_ARCHIVE_SUCCESS:
            return {
                ...state,
                bundleArchiveState: 'success',
                bundleArchiveResult: action.bundle,
            };
        case actions.BUNDLE_DELETE_REQUEST:
            return {
                ...state,
                bundleDeleteState: 'request',
            };
        case actions.BUNDLE_DELETE_SUCCESS:
            return {
                ...state,
                bundleDeleteState: 'success',
            };
        case actions.BUNDLE_CHANGE: {
            const bundle = {
                ...(action.reset ? initState.bundle : state.bundle),
                ...action.request,
            };

            if (!bundle.is_selling) {
                bundle.sale_description = null;
                bundle.sale_price = null;
                bundle.sale_account_id = null;
                bundle.default_sales_tax_code_id = null;
            }
            if (!bundle.is_buying) {
                bundle.purchase_description = null;
                bundle.purchase_price = null;
                bundle.purchase_account_id = null;
            }

            return {
                ...state,
                bundle,
                isSelling: bundle.is_selling,
                isBuying: bundle.is_buying,
            };
        }
        case actions.BUNDLE_CHANGE_IS_SELLING:
            return {
                ...state,
                isSelling: action.isSelling,
            };
        case actions.BUNDLE_CHANGE_IS_BUYING:
            return {
                ...state,
                isBuying: action.isBuying,
            };
        case actions.BUNDLE_SET_TOTAL:
            return {
                ...state,
                total: action.total,
            };
        case actions.BUNDLE_RESET_STATE:
            return {
                ...state,
                bundle: initState.bundle,
                itemWithPrice: initState.itemWithPrice,
                bundleWithPrice: initState.bundleWithPrice,
            };

        case actions.BUNDLE_READ_ITEM_PRICE_REQUEST:
            return {
                ...state,
                productId: action.productId,
                key: action.key,
                unitId: action.unitId,
                bundleReadItemPriceState: 'request',
            };
        case actions.BUNDLE_READ_ITEM_PRICE_SUCCESS:
            return {
                ...state,
                bundleReadItemPriceState: 'success',
                itemWithPrice: action.itemWithPrice,
            };

        case actions.BUNDLE_READ_ITEMS_PRICE_REQUEST:
            return {
                ...state,
                bundleReadItemsPriceState: 'request',
            };
        case actions.BUNDLE_READ_ITEMS_PRICE_SUCCESS:
            return {
                ...state,
                bundleReadItemsPriceState: 'success',
                bundleWithPrice: action.bundleWithPrice,
            };

        default:
            return state;
    }
}
